<template>
    <div class="landing-page home wefix">
        <!-- Hero banner -->
        <div class="hero-banner hero-banner-image-au">
            <div class="hero-overlay"></div>
            <div class="container">
                <h1>We come to you!</h1>
                <h4>Where do you want your smartphone repaired?</h4>
                <landing-page-address-search></landing-page-address-search>
            </div>
        </div>

        <!-- USP banner -->
        <div class="usp-banner">
            <div class="container">
                <div class="usp-container">
                    <div class="usp">
                        <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/icons/general/van-rapid.svg" class="usp-icon" alt="Same day service available" />
                        <p>
                            We come to you!
                        </p>
                    </div>
                    <div class="usp">
                        <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/icons/general/stopwatch.svg" class="usp-icon" alt="Fixed in minutes" />
                        <p>
                            Fixed in minutes
                        </p>
                    </div>
                    <div class="usp">
                        <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/icons/general/shield-check.svg" class="usp-icon" alt="12 month guarantee" />
                        <p>
                            12 month guarantee
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Most popular section -->
        <div class="most-popular-section">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="text-center">Most popular</h2>
<!--                        <b-tabs align="center" content-class="mt-3" v-model="tabIndex" lazy>-->
<!--                            <b-tab title="Smartphones" active></b-tab>-->
<!--                            <b-tab title="Tablets"></b-tab>-->
<!--                        </b-tabs>-->
<!--                        <hooper ref="mobileCarousel" :settings="hooperSettings" v-if="tabIndex === 0">-->
                        <hooper ref="mobileCarousel" :settings="hooperSettings">
                            <slide
                                    v-for="(popularMobile, index) in popularMobiles"
                                    :key="index">
                                <div class="card card-body">
                                    <img class="hooper-img device-img" :src="popularMobile.imagePath" :alt="popularMobile.title">
                                    <p>
                                        {{ popularMobile.title }}
                                    </p>
                                </div>
                            </slide>
                            <hooper-navigation slot="hooper-addons"></hooper-navigation>
                            <hooper-pagination slot="hooper-addons"></hooper-pagination>
                        </hooper>
<!--                        <hooper ref="tabletCarousel" :settings="hooperSettings" v-if="tabIndex === 1">-->
<!--                            <slide-->
<!--                                    v-for="(popularTablet, index) in popularTablets"-->
<!--                                    :key="index">-->
<!--                                <div class="card card-body">-->
<!--                                    <img class="hooper-img device-img" :src="popularTablet.imagePath" :alt="popularTablet.title">-->
<!--                                    <p>-->
<!--                                        {{ popularTablet.title }}-->
<!--                                    </p>-->
<!--                                </div>-->
<!--                            </slide>-->
<!--                            <hooper-navigation slot="hooper-addons"></hooper-navigation>-->
<!--                            <hooper-pagination slot="hooper-addons"></hooper-pagination>-->
<!--                        </hooper>-->
                    </div>
                </div>
            </div>
        </div>

        <!-- Steps section -->
        <div class="steps-section">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="text-center">A quick and easy way to repair your smartphone</h2>
                    </div>
                    <div class="col-12">
                        <ul class="steps">
                            <li class="step step-1">
                                <div class="step-icon">
                                    <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/landing-pages/wefix/step-1-pin.svg" alt="Step 1">
                                </div>
                                <div class="step-content">
                                    <h4>Enter a postcode</h4>
                                    <p>Home, work, hotel – wherever you are.</p>
                                </div>
                            </li>
                            <li class="step step-2">
                                <div class="step-icon">
                                    <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/landing-pages/wefix/step-2-pin.svg" alt="Step 2">
                                </div>
                                <div class="step-content">
                                    <h4>Select your device</h4>
                                    <p>Tell us what you need repairing – it’s easy.</p>
                                </div>
                            </li>
                            <li class="step step-3">
                                <div class="step-icon">
                                    <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/landing-pages/wefix/step-3-pin.svg" alt="Step 3">
                                </div>
                                <div class="step-content">
                                    <h4>Choose a repair date</h4>
                                    <p>Pick whenever works for you.</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- Technician tracking section -->
        <div class="technician-tracking-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 technician-tracking-image-container">
                        <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/landing-pages/wefix/technician-tracking.png" alt="Technician tracking" class="technician-tracking-image">
                    </div>
                    <div class="col-md-4">
                        <h2>Track your technician</h2>
                        <p>
                            Your Likewize Repair technician will arrive within an hour of the confirmed repair time. Watch them on their way to you, using the Likewize Repair online Tech Tracker.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Technician section -->
        <div class="technician-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                        <h2 class="text-center">The Likewize Repair fleet is on the road five days a week, powered by the mighty VW Transporter!</h2>
                    </div>
                    <div class="col-md-4">
                        <div class="card">
                            <div class="card-img-container">
                                <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/landing-pages/wefix/fleet-int.png" alt="Fleet">
                            </div>
                            <div class="card-body">
                                <h4>The Tech Team</h4>
                                <p>All Likewize Repair technicians are security cleared and fully trained with both Samsung and Apple.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card">
                            <div class="card-img-container">
                                <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/landing-pages/tesco-mobile/technician.png" alt="Technician">
                            </div>
                            <div class="card-body">
                                <h4>The right tools for the job</h4>
                                <p>Equipped with the latest tools, equipment and software, Likewize Repair is ready to repair even the very latest device.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card">
                            <div class="card-img-container">
                                <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/landing-pages/tesco-mobile/handover.png" alt="Handover device">
                            </div>
                            <div class="card-body">
                                <h4>More than just a man and a van</h4>
                                <p>Likewize Repair mobile workshops are custom-built to the highest lab-tech standards.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="trustpilot-banner">
                <h2>See what our customers are saying!</h2>

                <a href="https://au.trustpilot.com/review/wefix.com.au" target="_blank">
                    <img class="t-stars" src="https://res.cloudinary.com/wefix/image/upload/q_auto:low/v1552891141/general/sales/trustpilot/5stars.png"
                         alt="Trustpilot">
                    <br>
                    <img class="t-logo" src="https://res.cloudinary.com/wefix/image/upload/q_auto:low/v1552891141/general/sales/trustpilot/text-d-bgd156.png"
                         alt="Trustpilot">
                </a>

                <br>
                <a href="https://au.trustpilot.com/review/wefix.com.au" target="_blank">
                    <button class="btn w-line-button">READ REVIEWS</button>
                </a>
            </div>
        </div>

        <!-- Sub footer -->
        <div class="subfooter">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <p>
                            Likewize Repair is operated by Likewize Device Protection (Au) Pty Ltd. Parking required. Book online.
                        </p>
                        <p>
                            * Service available across Melbourne and Sydney, subject to address
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {
        Hooper,
        Navigation as HooperNavigation,
        Pagination as HooperPagination,
        Slide
    } from 'hooper'; // https://baianat.github.io/hooper/
    import 'hooper/dist/hooper.css';

    export default {
        data() {
            return {
                checkingPostcode: false,
                error: null,
                hooperSettings: {
                    infiniteScroll: true,
                    itemsToShow: 1.5,
                    itemsToSlide: 1,
                    wheelControl: false,
                    breakpoints: {
                        800: {
                            itemsToShow: 3,
                            itemsToSlide: 3
                        },
                        1000: {
                            itemsToShow: 5,
                            itemsToSlide: 5
                        }
                    }
                },
                popularMobiles: [
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/apple/phone/iphone-xr/black-real.png",
                        title: "Apple iPhone XR"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/apple/phone/iphone-11/black-real.png",
                        title: "Apple iPhone 11"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/phone/galaxy-s9/blue-coral-real.png",
                        title: "Samsung Galaxy S9"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/phone/galaxy-s20-4g/black-real.png",
                        title: "Samsung Galaxy S20"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/apple/phone/iphone-xs/gold-real.png",
                        title: "Apple iPhone XS"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/phone/galaxy-s10/s10-white-real.png",
                        title: "Samsung Galaxy S10"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/phone/galaxy-s10-plus/prism-silver-real.png",
                        title: "Samsung Galaxy S10+"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/phone/galaxy-s10e/prism-black-real.png",
                        title: "Samsung Galaxy S10e"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/apple/phone/iphone-x/white-real.png",
                        title: "Apple iPhone X"
                    },
                ],
                popularTablets: [
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/tablet/tab-a-10-1/white.svg",
                        title: "Samsung Tab A 10.1 (2016)"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/tablet/tab-s6/mountain-grey.svg",
                        title: "Samsung Tab S6"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/tablet/tab-s6-4g/mountain-grey.svg",
                        title: "Samsung Tab S6 4G"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/tablet/tab-a-8-0-4g-2019/black-1584017197.svg",
                        title: "Samsung Tab A 8.0 4G (2019)"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/tablet/tab-a-8-0-2019/black-1584364401.svg",
                        title: "Samsung Tab A 8.0 (2019)"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/tablet/tab-a-10-1-4g/black.svg",
                        title: "Samsung Tab A 10.1 4G (2016)"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/tablet/tab-a-10-1-s-pen-2016/black.svg",
                        title: "Samsung Tab A 10.1 S Pen (2016)"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/tablet/tab-a-10-1-2019/black.svg",
                        title: "Samsung Tab A 10.1 (2019)"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/tablet/tab-a-10-1-4g-2019/black.svg",
                        title: "Samsung Tab A 10.1 4G (2019)"
                    },
                    {
                        imagePath: "https://likewizerepair-uk.s3.eu-west-2.amazonaws.com/makes/samsung/tablet/tab-a-10-5/black.svg",
                        title: "Samsung Tab A 10.5"
                    },
                ],
                postcode: null,
                postcodeEmpty: false,
                tabIndex: 0
            }
        },

        components: {
            Hooper,
            HooperNavigation,
            HooperPagination,
            Slide
        },

        computed: {
            ...mapGetters([
                'bookingPostcode',
                'carrier',
                'requiresStore',
                'store',
                'useLoqate'
            ])
        },

        mounted() {
            window.location.replace('https://likewizerepair.com.au');
        }
    }
</script>

<style>
    .landing-page .most-popular-section .hooper {
        animation: none!important;
        opacity: 1!important;
    }

    .landing-page .coming-soon-banner {
      background: #f0ad4e;
      color: #f8f8f8;
    }

    .landing-page .coming-soon-banner .container{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    }

    .landing-page .coming-soon-banner p {
      font-family: "Poppins Bold", sans-serif;
      font-size: 1.1rem;
      font-weight: bold;
      margin: 0;
    }
</style>